<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import {BIconCaretLeftFill, BIconCaretRightFill, BIconExclamationSquare, BIconExclamationCircleFill} from 'bootstrap-vue'
import systemCode from "@/mixins/systemCode";
import router from "@/mixins/router";
import listDailyReportData from "@/mixins/daily_reports/list_by_factory";
import DatePicker from "vue2-datepicker";

export default {
  name: "ListDailyReportFactory",
  page: {
    title: "作業日報一覧（運搬）",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [systemCode, router, listDailyReportData],
  components: {
    Layout,
    BIconExclamationSquare,
    BIconExclamationCircleFill,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    DatePicker,
  },
  methods: {
    onChangeSelectedDate(){
      this.getData();
    },
  },
  computed: {
  }
};
</script>
<template>
  <Layout>
    <b-card>
      <div class="d-flex justify-content-end mb-3">
        <b-button variant="primary" size="lg"
                  @click="
              redirectRoute(
                'factories',
                {},
                { fromMenu: 0, date: filters.date }
              )
            "
            v-if="showSelectFactory"
        >
          工場選択
        </b-button>
      </div>
      <div class="d-flex justify-content-between mb-2">
        <span class="fw-bold">{{ '■' + vendorSiteName }}</span>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <div class="fw-bold">
            <span class="h4 mb-2 cursor-pointer">
              <b-icon-caret-left-fill variant="primary" @click="prevDate" v-if="showPrev"/>
            </span>
        </div>
        <div>
          <span>
            <date-picker
                  lang="ja"
                  :clearable="false"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD（ddd）"
                  value-type="YYYY-MM-DD"
                  position="left"
                  type="date"
                  v-model="filters.date"
                  @change="onChangeSelectedDate"
                >
          </date-picker>
          </span>
        </div>
        <div>
          <span class="h4 mb-2 cursor-pointer">
              <b-icon-caret-right-fill variant="primary" @click="nextDate" v-if="showNext"/>
            </span>
        </div>
      </div>
      <template v-for="(item, index) in data">
        <b-row class="mb-2" :id="`schedule_${index + 1}`">
          <b-col>
            <div class="d-inline-flex">
              <span class="badge mr-0dot5" :style="{'background-color': colorBadge5(item)}">{{ showBadge5(item) }}</span>
              <span class="badge mr-0dot5" :style="{ backgroundColor: getColorBadge7(item, index) + '!important', color:getColorTextBadge7(item, index)}">{{ showBadge7(item, index) }}</span>
              <span class="badge" :style="{ backgroundColor: getColorBadge6(item, index) + '!important', color:getColorTextBadge6(item, index)}">{{ showBadge6(item, index) }}</span>
            </div>
            <template v-if="showDateAlert(item)">
                <span class="ml-2">
                  <span class="h5">
                    <b-icon-exclamation-square/>
                  </span>
                  <span>
                    {{ formatMonthDayAlert(item) }}
                  </span>
                </span>
            </template>
          </b-col>
        </b-row>
        <table class="table table-bordered align-middle table-centered table-nowrap mb-0 table-sm">
          <tbody>
          <tr>
            <td width="110px">No</td>
            <td>{{ index + 1 }}</td>
          </tr>
          <tr>
            <td>作業時間</td>
            <td>
              <span v-if="item.schedule">{{ formatHour(item.schedule.start_datetime) }}</span>～<span v-if="item.schedule">{{ formatHour(item.schedule.end_datetime) }}</span>
            </td>
          </tr>
          <tr>
            <td>受付番号</td>
            <td>{{ item.schedule_id }}</td>
          </tr>
          <tr>
            <td>作業指示名</td>
            <td>
              <router-link
                v-if="item.work_order_json && item.work_order_json.case"
                :to="{ name: 'projects.sales.instructions.detail', params: { id: item.work_order_json.case.id, work_order_id: item.work_order_json.id  }, query: { readonly: true, daily_report_id: item.id } }"
              >
                {{ item.work_order_json.name }}
              </router-link>
            </td>
          </tr>
          <tr>
            <td>排出事業者</td>
            <td><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">{{ item.work_order_json.case.discharger.name }}</span></td>
          </tr>
          <tr>
            <td>排出事業者住所</td>
            <td>
                  <span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">
                    {{ showAddressDischarger(item) }}
                  </span>
            </td>
          </tr>
          <tr>
            <td>排出事業場</td>
            <td>
              <span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">{{ item.work_order_json.case.discharger_site.name }}</span>
            </td>
          </tr>
          <tr>
            <td>排出事業場住所</td>
            <td>
                  <span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">
                    {{ showAddressDischargerSite(item) }}
                  </span>
            </td>
          </tr>
          <tr v-if="!isStatus3(item)">
            <td>運搬事業者</td>
            <td><span v-if="item.schedule && item.schedule.vendor">{{ item.schedule.vendor.name }}</span></td>
          </tr>
          <tr>
            <td>処分事業者</td>
            <td><span v-if="vendorName(item)" v-html="vendorName(item)"></span></td>
          </tr>
          <tr>
            <td>処分事業者住所</td>
            <td><span v-html="vendorAddress(item)" v-if="vendorAddress(item)"></span></td>
          </tr>
          <tr>
            <td>処分事業場</td>
            <td><span v-if="vendorSiteNameForList(item)" v-html="vendorSiteNameForList(item)"></span></td>
          </tr>
          <tr>
            <td>処分事業場住所</td>
            <td><span v-html="vendorSiteAddress(item)" v-if="vendorSiteAddress(item)"></span></td>
          </tr>
          <tr>
            <td>車両</td>
            <td><span v-html="getCars(item.schedule)" v-if="item.schedule.assigned_cars_by_schedule"></span></td>
          </tr>
          <tr>
            <td>従業員</td>
            <td><span v-html="getStaffs(item.schedule)" v-if="item.schedule.assigned_staffs_by_schedule"></span></td>
          </tr>

        </tbody>
        </table>
        <div class="d-flex justify-content-end mb-3 mt-3">
          <button
            class="btn btn-primary w-md waves-effect waves-light"
            @click="
                redirectRoute(
                  'daily_reports.input',
                  { id: item.id },
                  { vendor_site_id: filters.factory_id, zz_vendor_site_4_id: filters.zz_vendor_site_4_id, index: index + 1, 
                    date: filters.date, discharger_site_id: filters.discharger_site_id },
                )
              "
          >
          
            日報入力
          </button>
        </div>
      </template>
    </b-card>
  </Layout>
</template>
<style lang="scss" scoped>
.labelC {
  padding: 10px;
  white-space:nowrap;
  font-weight: bold;
}
.contentC {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
.wrapC {
  margin-bottom: 10px;
  display: flex;
  column-gap: 0.5rem !important;
}
.blue {
  background: #92c4e7;
}
.green {
  background: #a6ddcb;
}
.badge {
  width: 100%;
  padding: 10px;
}
.orange {
  background: #d1885d!important;
}
.mr-10 {
  margin-left: 10px;
}
.grey {
  background: #f8f9fa;
}
.w-3 {
  width: 30%;
}
.mr-0dot5 {
  margin-right: 5px;
}
.badge {
  padding: 7px;
}
table tr td:first-child {
  background: #2cb57e;
  color: #ffffff;
}
.table-nowrap th, .table-nowrap td {
  white-space: normal;
}
.text-right {
  text-align: right;
}
</style>
